import classnames from 'classnames';
import React, { forwardRef } from 'react';
import { FontIcons } from '../../../../enums/font-icon.js';
import { StandardTextfield } from '../standard-textfield/standard-textfield.js';

/**
 * A convenience component for showing a search input with icon.
 *
 * The wrapping `<form>` element should have `role="search"`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/search
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/search_role
 *
 * @param props SearchTextfieldProps
 * @returns FunctionComponent<SearchTextfieldProps>
 */ const SearchTextfield = /*#__PURE__*/ forwardRef((props, ref)=>{
    return /*#__PURE__*/ React.createElement(StandardTextfield, {
        ...props,
        className: classnames({
            'bf-textfield__search': true,
            [`${props?.className}`]: !!props?.className
        }),
        leftIcon: FontIcons.Search,
        ref: ref,
        type: "search"
    });
});

export { SearchTextfield };
//# sourceMappingURL=search-textfield.js.map
